import {connect} from 'react-redux';

import List from '../components/list';

import getActiveFeatures from '../selectors/get-active-features';
import getAppStateHash from '../selectors/get-app-state-hash';

export default connect(
	(state) => ({
		features: getActiveFeatures(state),
		appStateHash: getAppStateHash(state),
	})
)(List);
